import React, { useState } from 'react';
import { 
  FaChartPie, FaChartLine, FaShieldAlt, FaCheckCircle, 
  FaChevronDown, FaCoins, FaBalanceScale, FaLandmark, FaRegClock 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const MutualFundsInvestment = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What is a Mutual Fund and how does it work?",
      a: "A mutual fund is a professionally managed investment vehicle that pools money from multiple investors to purchase a diversified basket of securities, such as stocks, bonds, or money market instruments. Each investor owns units representing a portion of the fund's overall holdings."
    },
    {
      q: "What is the difference between SIP and Lump-Sum investing?",
      a: "A Systematic Investment Plan (SIP) allows you to invest a fixed amount regularly (e.g., monthly), helping you average out market volatility through rupee cost averaging. A lump-sum investment involves investing a larger sum of money all at once, which is ideal when valuations are favorable or capital is readily available."
    },
    {
      q: "How does Lotoswealth select the right mutual funds for my portfolio?",
      a: "We evaluate mutual funds based on quantitative and qualitative parameters, including rolling returns, fund manager track records, expense ratios, portfolio turnover, risk-adjusted performance metrics (Sharpe/Sortino ratios), and consistency across market cycles."
    },
    {
      q: "Are mutual funds safe from market risk?",
      a: "Like all market-linked investments, mutual funds are subject to market risks. However, diversification across multiple companies, sectors, and asset classes significantly reduces single-stock concentration risk compared to direct equity investing."
    }
  ];

  return (
    <main className="mutual-funds-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Mutual Funds Investment Services in Hyderabad | SIP Investment | Lotoswealth</title>

  <meta
    name="description"
    content="Lotoswealth offers expert Mutual Funds Investment Services in Hyderabad, helping individuals and families build long-term wealth through SIPs, lump sum investments, equity funds, debt funds, hybrid funds, ELSS, and goal-based mutual fund investment strategies."
  />

  <meta
    name="keywords"
    content="Mutual Funds Investment Hyderabad, Mutual Funds Investment Services Hyderabad, Mutual Funds Hyderabad, SIP Investment Hyderabad, SIP Hyderabad, Systematic Investment Plan Hyderabad, Equity Mutual Funds Hyderabad, Debt Mutual Funds Hyderabad, Hybrid Mutual Funds Hyderabad, ELSS Mutual Funds Hyderabad, Tax Saving Mutual Funds Hyderabad, Investment Advisor Hyderabad, Financial Advisor Hyderabad, Wealth Management Hyderabad, Financial Planning Hyderabad, Goal Based Investment Hyderabad, Retirement Investment Hyderabad, Portfolio Management Hyderabad, Asset Management Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/mutual-funds-investment"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/mutual-funds-investment"
  />
  <meta
    property="og:title"
    content="Mutual Funds Investment Services in Hyderabad | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Grow your wealth with Mutual Funds Investment Services in Hyderabad. Invest in SIPs, equity funds, debt funds, hybrid funds, ELSS, and personalized mutual fund portfolios with Lotoswealth."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Mutual Funds Investment Services in Hyderabad | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Invest smarter with Mutual Funds Investment Services in Hyderabad. Expert SIP planning, diversified mutual fund portfolios, tax-saving investments, and long-term wealth creation."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/mutual-funds-investment.jpg" 
            alt="Mutual Funds Investment Advisory" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Curated Mutual Funds Investment
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Professional Fund Management for Disciplined Long-Term Growth
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Mutual funds offer one of the most accessible, transparent, and professionally managed pathways to wealth creation. Whether you are building an emergency fund, saving for a major life goal, or compounding retirement wealth, mutual funds provide instant diversification and expert oversight.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Navigating thousands of schemes across equity, debt, and hybrid categories can be challenging. Our expert advisors cut through the clutter, filtering top-performing funds through rigorous quantitative and qualitative research to construct a portfolio matched to your risk profile.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Harness the power of professional fund management and disciplined SIP investing to turn modest savings into substantial long-term wealth.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY MUTUAL FUNDS MATTER (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Choose Mutual Funds for Wealth Creation?
              </h2>
              <p className="text-muted line-height-lg">
                Mutual funds democratize investing, allowing individuals to access professionally managed, highly diversified portfolios without requiring massive capital outlays.
              </p>
              <p className="text-muted line-height-lg">
                Through disciplined Systematic Investment Plans (SIPs), investors harness rupee cost averaging and the compounding effect, removing the stress of market timing and building solid financial habits over time.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Key Benefits of Mutual Funds</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Professional Management:</strong> Experienced fund managers handle stock selection.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Instant Diversification:</strong> Spread risk across dozens of companies instantly.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Disciplined SIPs:</strong> Build wealth systematically with small monthly amounts.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>High Liquidity:</strong> Easy redemption and conversion back to cash when needed.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR MUTUAL FUND CATEGORIES (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">📊 Our Mutual Fund Categories & Strategies</h2>
            <p className="text-white">Comprehensive fund selection tailored for diverse risk appetites and horizons.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaChartLine size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Equity Funds (Growth)</h5>
                <p className="text-muted small">Focused on long-term capital appreciation by investing in large-cap, mid-cap, small-cap, and multi-cap companies. Ideal for goals 5+ years away.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBalanceScale size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Hybrid & Balanced Funds</h5>
                <p className="text-muted small">A strategic blend of equity and debt assets designed to provide moderate growth with built-in downside stability. Perfect for balanced risk profiles.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaShieldAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Debt & Liquid Funds</h5>
                <p className="text-muted small">Focused on capital preservation and steady income by investing in corporate bonds, government securities, and money market instruments.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaCoins size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Tax-Saving (ELSS) Funds</h5>
                <p className="text-muted small">Equity Linked Savings Schemes that offer dual benefits of capital growth and tax deductions under Section 80C with the shortest lock-in period.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaRegClock size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Systematic Investment Plans (SIP)</h5>
                <p className="text-muted small">Automated periodic contributions that enforce financial discipline and average out market volatility through rupee cost averaging.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaLandmark size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Thematic & Sectoral Funds</h5>
                <p className="text-muted small">Targeted exposure to high-growth themes such as technology, infrastructure, pharma, and consumption for aggressive alpha generation.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP SELECTION PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Our Mutual Fund Selection Process</h2>
            <p className="text-light opacity-75">Rigorous fund filtering to ensure your money is managed by the best.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Goal & Risk Profiling</h5>
                <p className="small text-muted mb-0">We assess your investment timeline, risk tolerance, and financial milestones to determine the right fund categories.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Quantitative Filtering</h5>
                <p className="small text-muted mb-0">Analyzing rolling returns, expense ratios, alpha, beta, and consistency across multiple market cycles.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – Qualitative Review</h5>
                <p className="small text-muted mb-0">Evaluating fund manager tenure, investment philosophy, risk management practices, and fund house stability.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Portfolio Construction</h5>
                <p className="small text-muted mb-0">Assembling a well-diversified mutual fund portfolio tailored to your goals, avoiding overlapping stock holdings across funds.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Ongoing Monitoring & Rebalancing</h5>
                <p className="small text-muted mb-0">Continuously tracking fund performance and rebalancing asset allocations as market conditions and goals evolve.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Benefits from Mutual Funds?</h3>
              <p className="text-muted small mb-4">Mutual funds are universally adaptable for various investor profiles:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "First-Time Investors", "Salaried SIP Contributors",
                  "Tax-Saving Seekers (ELSS)", "Goal-Oriented Planners",
                  "Retirement Corpus Builders", "Busy Professionals",
                  "Conservative Debt Investors", "Long-Term Wealth Creators"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Trust Lotoswealth?</h3>
                <p className="text-muted small mb-4">Selecting the right mutual fund requires unbiased research and professional oversight. Clients choose us because we offer:</p>
                <div className="row g-3">
                  {[
                    "Unbiased Fund Research & Filtering", "Customized SIP & Lump-Sum Strategies",
                    "Goal-Based Portfolio Construction", "Transparent Reporting & Tracking",
                    "Dedicated Relationship Advisors", "Regular Portfolio Health Reviews",
                    "Tax-Efficient Withdrawal Planning", "Client-Centric Long-Term Focus"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Mutual Funds & SIP Investing</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Start Your Mutual Fund SIP Journey?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Build a professionally managed, diversified mutual fund portfolio tailored to your financial milestones. Connect with our advisors today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule a Mutual Fund Consultation
          </button>
        </div>
      </section>

    </main>
  );
};

export default MutualFundsInvestment;